<div class="documentContainer flex flex-column gap-3 surface-200 border-round-md">
  <div class="flex justify-content-center pt-4 pb-4 pl-3 pr-3">
    <app-svg-icon iconName="docs" iconColor="primary" iconSize="xxl"></app-svg-icon>
  </div>
  <div class="flex p-3 justify-content-between surface-50 border-round-bottom-md">
    <div class="flex flex-column">
      @if (config()?.label) {
        <span class="font-size-xl font-semibold"> {{ config()?.label ?? "" | translate }} {{ config()?.id }}</span>
      } @else {
        <span class="font-size-xl font-italic"> {{ "protocols.label_missing" | translate }}</span>
      }

      <span class="font-size-xs"> {{ convertToTimeString(config()?.timestamp) }}</span>
    </div>
    <div class="flex gap-4">
      <!-- <app-svg-icon
        class="pointer align-content-center"
        (click)="onEmailClick(config.id)"
        iconName="send_mail"
        iconColor="primary"
      >
      </app-svg-icon> -->
      <app-svg-icon class="pointer align-content-center" (click)="onOpenClick()" iconName="eye" iconColor="primary">
      </app-svg-icon>
    </div>
  </div>
</div>
